// extracted by mini-css-extract-plugin
module.exports = {"BusinessOwners":"businessOwnersList_BusinessOwners__RDKRa","BusinessOwner":"businessOwnersList_BusinessOwner__PjN3b","Initials":"businessOwnersList_Initials__KVqRI"};